import React from "react";
import PropTypes from "prop-types";
import styles from "./style.module.scss";
import PaginationButton from "./PaginationButton";

const Pagination = ({ next, prev }) => (
  <div className={styles.pagination}>
    <PaginationButton link={prev} text="Prev" />
    <PaginationButton link={next} text="Next" />
  </div>
);

Pagination.propTypes = {
  next: PropTypes.shape({
    title: PropTypes.string,
    slug: PropTypes.string
  }),
  prev: PropTypes.shape({
    title: PropTypes.string,
    slug: PropTypes.string
  })
};

Pagination.defaultProps = {
  next: null,
  prev: null
};

export default Pagination;
